// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// COMPANY SCHEMA
/////////////////////////////////////////

export const CompanySchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  domainName: z.string(),
  name: z.string(),
  founded: z.string().nullable(),
  founders: z.string().array(),
  headquarters: z.string().nullable(),
  mission: z.string().nullable(),
  keyProducts: z.string().array(),
  description: z.string().nullable(),
  publiclyTraded: z.boolean(),
  tickerSymbol: z.string().nullable(),
  stockExchange: z.string().nullable(),
  stockPerformance: z.string().nullable(),
  primaryIndustry: z.string().nullable(),
  secondaryIndustries: z.string().array(),
  numberOfEmployees: z.string().nullable(),
  globalPresence: z.string().array(),
  regulatoryRisks: z.string().array(),
  marketRisks: z.string().array(),
  technologicalRisks: z.string().array(),
  operationalRisks: z.string().array(),
  esgRisks: z.string().array(),
  pastBreaches: z.string().array(),
  breachDetails: z.string().array(),
  preventativeMeasures: z.string().array(),
  revenue: z.string().nullable(),
  profitability: z.string().nullable(),
  keyMetrics: z.string().array(),
  recentNews: z.string().array(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type Company = z.infer<typeof CompanySchema>

export default CompanySchema;
